import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import { ICampaignCertificationResponse } from "../../../models/Recertification";
import {
  LIST_IDENTIFIER,
  CERTIFICATION_REFERENCE_IDENTIFIER,
  LOADER_IDENTIFIER,
  SELECTED_ITEM,
} from "./constants";

const {
  STEP_ONE,
  RAW_LIST,
  SELECTED_CERTIFICATION,
  STEP_TWO,
  STEP_THREE,
  CONFIRM_EXECUTION,
  CALL_STATE,
  REVISORS,
  EDIT_PERIMETER_GROUPS,
  EDIT_PERIMETER_OWNERSHIP,
  GROUPS,
  ADDED_GROUPS,
  TAB_SELECTED_IDENTIFIER,
  SUPERVISORS,
  ADDED_SUPERVISORS,
  ENTITLEMENTS,
  ADDED_ENTITLEMENTS,
  EDIT_PERIMETER_USERS,
  USERS,
  ADDED_USERS,
  EDIT_PERIMETER_BRS,
  BR,
  ADDED_BR,
  EDIT_PERIMETER_APPLICATIONS,
  APPLICATIONS,
  ADDED_APPLICATIONS,
  CONFIRM_MODAL_TRIGGER,
  TABS_IDENTIFIER,
  USER_LIST_IDENTIFIER,
  OU_LIST_IDENTIFIER,
  BR_LIST_IDENTIFIER,
  ENTITLEMENT_LIST_IDENTIFIER,
  ACCOUNT_LIST_IDENTIFIER,
  APPLICATION_LIST_IDENTIFIER,
  ITEM_LIST_IDENTIFIER,
  CURRENT_USER,
  IS_ADMIN,
  IS_SUPERVISOR,
  EDIT_REVISOR,
  ITEM_IDENTIFIER,
  AGGREGATE_OU_ITEMS,
  AGGREGATE_BR_ITEMS,
  AGGREGATE_USER_ITEMS,
  AGGREGATE_ENTITLEMENTS_ITEMS,
  ACCESS_ROLE,
  CAMPAIGN_CONFIG,
  CAMPAIGN_REVISORS,
  CAMPAIGN_REVISORS_LOADER,
  IMPERSONIFICATION,
  ITEM_DETAIL,
  TECHNICAL_USER_LIST_IDENTIFIER,
  EDIT_PERIMETER_TECHNICAL_USERS,
  TECHNICAL_USERS,
  ADDED_TECHNICAL_USERS,
  AGGREGATE_TECHNICAL_USERS_ITEMS,
} = CERTIFICATION_REFERENCE_IDENTIFIER;
export default {
  [ITEM_DETAIL]: null,
  [IMPERSONIFICATION]: null,
  [ACCESS_ROLE]: null,
  [SELECTED_CERTIFICATION]: {},
  [CAMPAIGN_CONFIG]: {},
  [CONFIRM_EXECUTION]: {
    type: "",
    certificationItemType: "",
    state: false,
    listIds: [],
  },
  [CURRENT_USER]: {
    [IS_ADMIN]: false,
    [IS_SUPERVISOR]: false,
  },
  [CALL_STATE]: IResponseState.PENDING,
  [CONFIRM_MODAL_TRIGGER]: false,
  [STEP_ONE]: {
    [RAW_LIST]: [],
    [LIST_IDENTIFIER]: {} as ICampaignCertificationResponse,
    [LOADER_IDENTIFIER]: false,
  },
  [STEP_TWO]: {
    [LOADER_IDENTIFIER]: false,
    [TABS_IDENTIFIER]: {
      [USER_LIST_IDENTIFIER]: {},
      [OU_LIST_IDENTIFIER]: {},
      [BR_LIST_IDENTIFIER]: {},
      [ENTITLEMENT_LIST_IDENTIFIER]: {},
      [ACCOUNT_LIST_IDENTIFIER]: {},
      [APPLICATION_LIST_IDENTIFIER]: {},
      [TECHNICAL_USER_LIST_IDENTIFIER]: {},
      [ITEM_LIST_IDENTIFIER]: {},
      [LOADER_IDENTIFIER]: false,
    },
    [CAMPAIGN_REVISORS]: {},
    [CAMPAIGN_REVISORS_LOADER]: false,
  },
  [STEP_THREE]: {
    [SELECTED_ITEM]: {},
    [REVISORS]: { [LIST_IDENTIFIER]: [], [LOADER_IDENTIFIER]: false },
    [LIST_IDENTIFIER]: {},
    [LOADER_IDENTIFIER]: false,
  },

  [EDIT_PERIMETER_GROUPS]: {
    [GROUPS]: { [LIST_IDENTIFIER]: [], [LOADER_IDENTIFIER]: false },
    [ADDED_GROUPS]: [],
    [TAB_SELECTED_IDENTIFIER]: "WHITE",
  },
  [EDIT_PERIMETER_TECHNICAL_USERS]: {
    [TECHNICAL_USERS]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
    },
    [ADDED_TECHNICAL_USERS]: [],
    [TAB_SELECTED_IDENTIFIER]: "WHITE",
  },
  [EDIT_PERIMETER_OWNERSHIP]: {
    [ENTITLEMENTS]: { [LIST_IDENTIFIER]: [], [LOADER_IDENTIFIER]: false },
    [ADDED_ENTITLEMENTS]: [],
    [TAB_SELECTED_IDENTIFIER]: "WHITE",
  },
  [EDIT_PERIMETER_USERS]: {
    [USERS]: { [LIST_IDENTIFIER]: [], [LOADER_IDENTIFIER]: false },
    [ADDED_USERS]: [],
    [TAB_SELECTED_IDENTIFIER]: "WHITE",
  },
  [EDIT_PERIMETER_BRS]: {
    [BR]: { [LIST_IDENTIFIER]: [], [LOADER_IDENTIFIER]: false },
    [ADDED_BR]: [],
    [TAB_SELECTED_IDENTIFIER]: "WHITE",
  },
  [EDIT_PERIMETER_APPLICATIONS]: {
    [APPLICATIONS]: { [LIST_IDENTIFIER]: [], [LOADER_IDENTIFIER]: false },
    [ADDED_APPLICATIONS]: [],
    [TAB_SELECTED_IDENTIFIER]: "WHITE",
  },
  [SUPERVISORS]: {
    [SUPERVISORS]: { [LIST_IDENTIFIER]: [], [LOADER_IDENTIFIER]: false },
    [ADDED_SUPERVISORS]: [],
  },
  [EDIT_REVISOR]: {
    [ITEM_IDENTIFIER]: [],
    [AGGREGATE_OU_ITEMS]: [],
    [AGGREGATE_BR_ITEMS]: [],
    [AGGREGATE_USER_ITEMS]: [],
    [AGGREGATE_ENTITLEMENTS_ITEMS]: [],
    [AGGREGATE_TECHNICAL_USERS_ITEMS]: [],
  },
};
